import React from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import { Divider } from "antd";

import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";

import { PageHeader, Button, Popconfirm, Space, Switch } from "antd";
import Moment from "moment";
import { DATE_FORMAT } from "../../../../../core/utils/i18n-js";

import { AmountText } from "../../../../../core/components/widget/amountInline";

import BasicList from "../../../../../core/components/list";

import { basicDeleteActionField } from "../../../../../components/table/fields/common";

import { configureSort } from "../../../../../core/utils/list";

import { LAYOUT_FINANCE_PAYMENT_CLIENT_SHOW, LAYOUT_FINANCE_PAYMENT_CLIENT_NEW } from "../../../navigation";

const columnsAntd = (props) => {
    const { remove, clientsById, loading, filters } = props;

    if (loading) {
        return [];
    }

    return [
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
            ...configureSort(filters.sort, filters.direction, "p.id"),
            fixed: "left",
            ellipsis: true,
            render: (id, record) => <Link to={LAYOUT_FINANCE_PAYMENT_CLIENT_SHOW(record.id)}>{id}</Link>,
        },
        {
            title: "Client",
            dataIndex: "client",
            key: "client",
            render: (client) => {
                if (client && clientsById) {
                    return <>{clientsById[client]?.name}</>;
                }
            },
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            ...configureSort(filters.sort, filters.direction, "p.date"),
            render: (date) => {
                if (date) return <>{Moment(date).format(DATE_FORMAT)}</>;
            },
        },
        {
            title: "Notes",
            dataIndex: "notes",
            key: "notes",
            ellipsis: true,
        },
        {
            title: "Amount",
            dataIndex: "amountValue",
            ...configureSort(filters.sort, filters.direction, "p.amountValue"),
            sorter: true,
            render: (amount, record) => {
                return <AmountText value={amount} type={record.amountType} />;
            },
        },
        basicDeleteActionField({ remove: props.remove, loading: props.actionLoading }),
    ];
};

const Filters = (props) => {
    const { filters } = props;
    const isActive = filters ? filters.active == 1 : false;

    return (
        <Space size="small">
            <Switch
                checked={isActive}
                size="small"
                onChange={(bool) => props.onUpdateFilters({ active: bool ? 1 : 0 })}
            />{" "}
            Actives
        </Space>
    );
};

const Listado = (props) => {
    const _goBack = () => {
        props.history.goBack();
    };

    const { data, loading, parameters, meta, filters } = props;

    const total = !loading && meta ? meta.total : 0;

    const pagination = {
        current: meta.current ? meta.current : "1",
        pageSize: meta.pageSize ? meta.pageSize : "20",
        total: meta.total ? meta.total : "0",
    };

    return (
        <BasicList
            titulo={"PAYMENTS (" + total + ")"}
            subtitulo="List"
            onPressBack={_goBack}
            onPressNew={LAYOUT_FINANCE_PAYMENT_CLIENT_NEW("")}
            onSearchByText={(text) => props.onUpdateFilters({ text })}
            textFilter={filters ? filters.text : ""}
        >
            <Filters {...props} />
            <Divider />

            <Table
                bordered={true}
                size="small"
                rowKey={(row) => row.id}
                dataSource={data}
                columns={columnsAntd(props)}
                loading={loading}
                pagination={pagination}
                onChange={props.handleTableChange}
            />
        </BasicList>
    );
};

export default Listado;
